import * as React from 'react';
import { NavLink } from 'react-router-dom';
const classNames = require('classnames');

import Utils from '../../common/utils';
import { Button } from '../../components/buttons';
import { IconChevronDown } from '../../components/icons';

interface Props {
	className?: string;
	tabs: Array<any>;
	toggleLabel?: string;
	match?: any;
	disableDocTitle?: boolean;
}

interface State {
	isTabExpanded: boolean;
}

class Tabs extends React.Component<Props, State> {
	constructor(props: any) {
		super(props);
		this.state = {
			isTabExpanded: false
		};
	}

	componentDidMount() {
		if (!this.props.disableDocTitle) {
			Utils.setDocTitle(this.getTabTitle(this.props.tabs));
		}
	}

	componentWillReceiveProps(nextProps: Props) {
		if (!this.props.disableDocTitle && nextProps.match.params.tab !== this.props.match.params.tab) {
			Utils.setDocTitle(this.getTabTitle(nextProps.tabs, nextProps.match.url));
		}
	}

	getTabTitle = (tabs: any, url: string = this.props.match.url, defaultTitle?: string) => {
		let title = defaultTitle || '';

		tabs.forEach((tab: any) => {
			if (tab.to === url) {
				title = tab.label;
			}
		});

		return title;
	}

	onTabToggle = (state?: string) => {
		let isOpened = !this.state.isTabExpanded;
		switch (state) {
			case 'open':
				isOpened = true;
				break;
			case 'close':
				isOpened = false;
				break;
			default:
				break;
		}

		// Close the tab toggle if the user clicks anywhere
		if (isOpened) {
			document.body.addEventListener('click', () => this.onTabToggle('close'));
		} else {
			document.body.removeEventListener('click', () => this.onTabToggle('close'));
		}

		this.setState({ isTabExpanded: isOpened });
	}

	render() {
		const { ...props } = this.props;
		return props.tabs.length > 0 ? (
			<div className={classNames('tab-wrapper mb-4 mb-md-5', props.className)}>
				<Button className={`tab-toggler${this.state.isTabExpanded ? ' active' : ''}`} onClick={this.onTabToggle}>
					<span className="tab-toggler-label align-middle">
						{this.getTabTitle(props.tabs, props.toggleLabel, 'Select a page...')}
					</span>
					<IconChevronDown className="tab-toggler-icon" />
				</Button>
				<div className={`tab-collapse${this.state.isTabExpanded ? '' : ' collapsed'}`}>
					{props.tabs.map((tab, index) => (
						<NavLink className={`btn btn-outline-secondary tab`} to={tab.to} key={index}>
							{tab.label}
						</NavLink>
					))}
				</div>
			</div>
		) : null;
	}
}

export default Tabs;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/common/Tabs.tsx